import { render, staticRenderFns } from "./result_submition.vue?vue&type=template&id=69bf16ba&scoped=true&"
import script from "./result_submition.vue?vue&type=script&lang=js&"
export * from "./result_submition.vue?vue&type=script&lang=js&"
import style0 from "./result_submition.vue?vue&type=style&index=0&id=69bf16ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf16ba",
  null
  
)

export default component.exports